import '../styles/pages/products.scss'
import ReactGA from 'react-ga4'
import Title from '../components/ui/Title'

import { useEffect, useState } from 'react'

export const Products = () => {
    const gameData = {
        path: 'legend-heroes-trails-zero', // 1 Please input game pathname
        steam: '1668510', // 2 Please input Steam ID if available
    }
    const gameData2 = {
        path: 'reynatis', // 1 Please input game pathname
        steam: '1668510', // 2 Please input Steam ID if available
    }
    const imagePath = {
        'PlayStation®5': 'ps5',
        'PlayStation®4': 'ps4',
        Xbox: 'xbox',
        'Nintendo Switch™': 'nsw',
        'Nintendo Switch™2': 'ns2',
    }

    const [editions, setEditions] = useState([])
    const [crossBellEditions, setCrossBellEditions] = useState([])
    // const [limitedEditions, setLimitedEditions] = useState([])
    const [data, setData] = useState([])
    const [crossbellData, setCrossbellData] = useState([])
    const [platformDeluxe, setPlatformDeluxe] = useState('Nintendo Switch™2')
    const dataReduced = Object.values(data).reduce((acc, curr) => {
        if (curr.edition !== 'Limited Edition' && curr.platform !== 'PC' && !acc.includes(curr.edition)) {
            acc.push(curr.edition)
        }
        return acc
    }, [])
    const platformReduced = Object.values(data).reduce((acc, curr) => {
        if (curr.platform !== 'PC' && curr.platform !== 'Xbox One' && !acc.includes(curr.platform)) {
            acc.push(curr.platform)
        }

        return acc
    }, [])

    useEffect(() => {
        fetch(`https://www.nisamerica.com/api/game/${gameData.path}`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText)
                }
                return response.json()
            })
            .then((data) => {
                const editions = Object.values(data.game.retailerLinks.map((item) => item.edition))
                const formattedData = data.game.retailerLinks.map((item) => {
                    return {
                        url: item.url,
                        store: item.store,
                        edition: item.edition,
                        platform: item.platform,
                        region: item.region,
                    }
                })
                // Sort retaiers in alphabetical order
                const sortedData = formattedData.sort((a, b) => a.store.localeCompare(b.store))
                setEditions(editions)
                setData(sortedData)
            })
            .catch((error) => {
                console.error('There has been a problem with your fetch operation:', error)
            })
    }, [])
    useEffect(() => {
        fetch(`https://www.nisamerica.com/api/game/${gameData2.path}`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText)
                }
                return response.json()
            })
            .then((data) => {
                const crossbelleditions = Object.values(data.game.retailerLinks.map((item) => item.edition))
                const formattedData = data.game.retailerLinks.map((item) => {
                    return {
                        url: item.url,
                        store: item.store,
                        edition: item.edition,
                        platform: item.platform,
                        region: item.region,
                    }
                })
                // Sort retaiers in alphabetical order
                const sortedData = formattedData.sort((a, b) => a.store.localeCompare(b.store))
                setCrossBellEditions(crossbelleditions)
                setCrossbellData(sortedData)
            })
            .catch((error) => {
                console.error('There has been a problem with your fetch operation:', error)
            })
    }, [])
    const FilterLE = (region) =>
        crossbellData.filter((item) => item.region === region && item.edition === 'Limited Edition')
    const FilterRegion = (region, platform) =>
        data.filter((item) => item.region === region && item.edition === 'Deluxe Edition' && item.platform === platform)
    const ButtonPlatformSelecter = ({ children, link, gaCategory, gaLabel, onClickEvent, active }) => {
        return (
            <>
                <button
                    onClick={
                        (() => {
                            ReactGA.event({
                                action: 'click',
                                event: 'link',
                                category: { gaCategory },
                                label: { gaLabel },
                            })
                        },
                        onClickEvent)
                    }
                    to={link}
                    activeclassname='active'
                    className={`${active ? 'active-platform' : 'inactive-platform'} platform-button`}
                >
                    <p className='not-italic'>{children}</p>
                    {active && (
                        <i>
                            <svg xmlns='http://www.w3.org/2000/svg' width='12' height='14' viewBox='0 0 9 14'>
                                <path
                                    d='M7,0l7,9H0Z'
                                    transform='translate(9) rotate(90)'
                                    fill='rgb(4, 172, 198)'
                                ></path>
                            </svg>
                        </i>
                    )}
                </button>
            </>
        )
    }
    const ButtonRetailer = ({ dataPlatform, dataUrl, dataStore }) => {
        return (
            <button className='retailer-button'>
                <a
                    onClick={() => {
                        ReactGA.event({
                            action: 'click',
                            event: 'link',
                            category: 'Products',
                            label: `DE ${dataPlatform} ${dataStore}`,
                        })
                    }}
                    target='_blank'
                    rel='noreferrer'
                    href={`${dataUrl}`}
                >
                    <p>{dataStore}</p>
                </a>
            </button>
        )
    }

    return (
        <>
            <div className='page-container-products'>
                <Title text='Products' size='full' />
                <nav className='media-nav'>
                    <a href='#lmtedition'>
                        {' '}
                        <h1 className='media-link'>Limited Edition</h1>
                    </a>

                    <a href='#dlxedition'>
                        {' '}
                        <h1 className='media-link'>Deluxe Edition</h1>
                    </a>

                    <a href='#digital'>
                        {' '}
                        <h1 className='media-link'>Digital Edition</h1>
                    </a>            
                </nav>
              
                {editions.includes('Limited Edition') && (
                    <section id='ltdedition' className='section'>
                        {/* <h1 className=''>Limited Edition</h1>{' '} */}
                        <div className='products-title'>
                            <h1 className=''>Limited Edition</h1>
                            {/* <h2 className=''>Available Now</h2> */}
                        </div>
                        <div className='glamshot'>
                            <img
                                src={`./img/le-ps5-1.webp`}
                                // src={`${process.env.PUBLIC_URL}/assets/le.jpg`}
                                alt='le glamshot'
                            />
                        </div>{' '}
                        <div className='captcha-container'>
                            <h3 className=''>NIS America Online Store</h3>
                            {/* <h2 className=''>Available Now</h2> */}
                        </div>
                        <div className='le-buttons'>
                          
                                <button>
                                    <a
                                        onClick={() => {
                                            ReactGA.event({
                                                action: 'click',
                                                event: 'link',
                                                category: 'Products',
                                                label: `Limited Edition - PS5 - NISA Online Store`,
                                            })
                                        }}
                                        target='_blank'
                                        rel='noreferrer'
                                        href={`https://store.nisamerica.com/products/crossbell-limited-edition?variant=43053256048688`}
                                    >
                                        <p>PlayStation®5</p>
                                    </a>
                                </button>
                                <button>
                                    <a
                                        onClick={() => {
                                            ReactGA.event({
                                                action: 'click',
                                                event: 'link',
                                                category: 'Products',
                                                label: `Limited Edition - NS2 - NISA Online Store`,
                                            })
                                        }}
                                        target='_blank'
                                        rel='noreferrer'
                                        href={`https://store.nisamerica.com/products/crossbell-limited-edition?variant=43053256015920`}
                                    >
                                        <p>Nintendo Switch™2</p>
                                    </a>
                                </button>
                        </div>
                    </section>
                )}
                <section id='dlxedition' className='section'>
                <div className='products-title'>
                            <h1 className=''>Deluxe Edition</h1>
                            {/* <h2 className=''>Available Now</h2> */}
                        </div>
                    <div className='de-container'>
                        <div className='platform-selecter'>
                            <ButtonPlatformSelecter
                                onClickEvent={() => setPlatformDeluxe('Nintendo Switch™2')}
                                active={platformDeluxe === 'Nintendo Switch™2'}
                            >
                                Nintendo Switch™2
                            </ButtonPlatformSelecter>
                            <ButtonPlatformSelecter
                                onClickEvent={() => setPlatformDeluxe('Nintendo Switch™')}
                                active={platformDeluxe === 'Nintendo Switch™'}
                            >
                                Nintendo Switch™
                            </ButtonPlatformSelecter>
                            <ButtonPlatformSelecter
                                onClickEvent={() => setPlatformDeluxe('PlayStation®5')}
                                active={platformDeluxe === 'PlayStation®5'}
                            >
                                PlayStation®5
                            </ButtonPlatformSelecter>
                            <ButtonPlatformSelecter
                                onClickEvent={() => setPlatformDeluxe('PlayStation®4')}
                                active={platformDeluxe === 'PlayStation®4'}
                            >
                                PlayStation®4
                            </ButtonPlatformSelecter>
                        </div>{' '}
                        <div className='de-wrapper'>
                            <div className='de-glamshot'>
                                <img
                                    className='packshot'
                                    src={`./img/products/de-${imagePath[platformDeluxe]}.webp`}
                                    alt={`Deluxe Edition ${imagePath[platformDeluxe]}`}
                                />
                            </div>
                            <h2 className=''>
                                <div className=''>
                                    <h2 className='available-now'>
                                        {imagePath[platformDeluxe] === 'ps5' || imagePath[platformDeluxe] === 'ns2'
                                            ? 'Coming September 10, 2026'
                                            : 'Available Now'}
                                    </h2>
                                </div>
                            </h2>
                            <div>
                                {FilterRegion('NA', platformDeluxe).length > 0 && (
                                    <div className=''>
                                        {' '}
                                        <div className='captcha-container'>
                                            <h3>North America</h3>
                                        </div>
                                        <div className='retailer-buttons'>
                                            {FilterRegion('NA', platformDeluxe).map((data, i) => (
                                                <div key={i}>
                                                    <ButtonRetailer
                                                        dataPlatform={data.platform}
                                                        dataUrl={data.url}
                                                        dataStore={data.store}
                                                        gaCategory='Product'
                                                        gaLabel={`NA - Deluxe Edition - ${data.platform} - ${data.store}`}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {FilterRegion('EU', platformDeluxe).length > 0 && (
                                    <div>
                                        {' '}
                                        <div className='captcha-container'>
                                            <h3>Europe</h3>
                                        </div>
                                        <div className='retailer-buttons'>
                                            {FilterRegion('EU', platformDeluxe).map((data, i) => (
                                                <div key={i}>
                                                    <ButtonRetailer
                                                        dataPlatform={data.platform}
                                                        dataUrl={data.url}
                                                        dataStore={data.store}
                                                        gaCategory='Product'
                                                        gaLabel={`EU - Deluxe Edition - ${data.platform} - ${data.store}`}
                                                    />{' '}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {FilterRegion('ANZ', platformDeluxe).length > 0 && (
                                    <div>
                                        <h3>Oceania</h3>
                                        <div className='retailer-buttons'>
                                            {FilterRegion('ANZ', platformDeluxe).map((data, i) => (
                                                <div key={i}>
                                                    <ButtonRetailer
                                                        dataPlatform={data.platform}
                                                        dataUrl={data.url}
                                                        dataStore={data.store}
                                                        gaCategory='Product'
                                                        gaLabel={`ANZ - Deluxe Edition - ${data.platform} - ${data.store}`}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>{' '}
                    </div>
                </section>
                <section id='digital' className='section'>
                <div className='products-title'>
                            <h1 className=''>Digital Edition</h1>
                            {/* <h2 className=''>Available Now</h2> */}
                        </div>
                    <div className='steamcontainer'>
                        <iframe
                            title={gameData.path}
                            src={`https://store.steampowered.com/widget/${gameData.steam}/`}
                            style={{ maxWidth: '900px' }}
                            frameBorder='0'
                            onClick={() => {
                                ReactGA.event({
                                    action: 'click',
                                    event: 'link',
                                    category: 'Product',
                                    label: 'Deluxe Ediiton - PC - Steam',
                                })
                            }}
                        ></iframe>
                    </div>
                </section>
            </div>
        </>
    )
}
export default Products
